import type { ReactNode } from "react";
import { cx } from "./cx";

export type PillTone = "ok" | "warn" | "danger" | "neutral";

export interface PillProps {
  tone: PillTone;
  children: ReactNode;
  title?: string;
  className?: string;
}

export function Pill({ tone, children, title, className }: PillProps) {
  return (
    <span className={cx("pill", tone !== "neutral" && tone, className)} title={title}>
      {children}
    </span>
  );
}
